import React from "react";
import { Table } from "reactstrap";
import { resolveAssetNameDisplay } from "../../../../utils/otherValueDisplay";

const formatMetres = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    const num = Number(value);
    if (Number.isNaN(num)) return String(value);
    return `${num}`;
};

const formatMoney = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    const num = Number(value);
    if (Number.isNaN(num)) return String(value);
    return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const InfrastructureTab = ({ assets = [] }) => {
    if (assets.length === 0) {
        return <p className="text-center text-muted py-4">No infrastructure assets recorded.</p>;
    }

    const refNumbers = [
        ...new Set(
            assets
                .map((asset) => asset.reference_number || asset.valuation_ref || "")
                .filter(Boolean)
        ),
    ];

    const groupColors = ["#e8f0f5", "#ffffff"];

    return (
        <Table responsive hover bordered>
            <thead style={{ backgroundColor: "#0147C8", color: "white" }}>
                <tr>
                    <th style={{ width: "50px" }}>#</th>
                    <th>Reference Number</th>
                    <th>Name</th>
                    <th>Type of Bridge</th>
                    <th>Width (m)</th>
                    <th>Span (m)</th>
                    <th>Ward / Street</th>
                    <th>Condition</th>
                    <th>Replacement Cost</th>
                    <th>Fair Value</th>
                    <th>Valuer</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                {assets.map((a, index) => {
                    const condition = a.observed_condition_name || a.observed_condition || "-";
                    const valuation = a.asset_valuation || a.assetValuation || a.valuation;
                    const valuer = valuation?.valuer_user || valuation?.valuerUser;
                    const valuerName =
                        a.valuer_name ||
                        a.valuerName ||
                        (valuer
                            ? [
                                  valuer.first_name || valuer.firstName || "",
                                  valuer.middle_name || valuer.middleName || "",
                                  valuer.last_name || valuer.lastName || "",
                              ]
                                  .filter(Boolean)
                                  .join(" ")
                            : "-");

                    const currentRef = a.reference_number || a.valuation_ref || "";
                    const refIndex = refNumbers.indexOf(currentRef);
                    const colorIndex = refIndex >= 0 ? refIndex % groupColors.length : 1;
                    const rowBgColor = currentRef ? groupColors[colorIndex] : "#ffffff";
                    const rowClassName = currentRef ? `ref-group-${colorIndex}` : "";

                    const wardName =
                        a.ward?.name || a.ward_name || a.wardName || "";
                    const street = a.street || "";
                    const location = [wardName, street].filter(Boolean).join(" / ") || "-";

                    return (
                        <tr key={a.id} className={rowClassName} style={{ backgroundColor: rowBgColor }}>
                            <td className="fw-bold text-muted">{index + 1}</td>
                            <td>{currentRef || "-"}</td>
                            <td>
                                <strong>{resolveAssetNameDisplay(a)}</strong>
                            </td>
                            <td>{a.type_of_bridge || a.typeOfBridge || "-"}</td>
                            <td>{formatMetres(a.width_m ?? a.widthM)}</td>
                            <td>{formatMetres(a.span_m ?? a.spanM)}</td>
                            <td>{location}</td>
                            <td>{condition}</td>
                            <td>{formatMoney(a.current_replacement_cost ?? a.currentReplacementCost)}</td>
                            <td>{formatMoney(a.fair_value ?? a.fairValue)}</td>
                            <td>{valuerName || "-"}</td>
                            <td>{a.status || a.valuation_status || "-"}</td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

export default InfrastructureTab;
